import { useState } from "react";

const Contact = () => {
  const scriptURL_SAVE = "https://script.google.com/macros/s/AKfycby57Q56l-JkwDQIcmJ3gxV-ZGCBViBmfD4J4r_0ir2ZYmBNkUmgHyFoaczMXCDxfwfn/exec";
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Prepare form data
      const formSubmissionData = new FormData();
      formSubmissionData.append("Name", formData.name);
      formSubmissionData.append("Email", formData.email);
      formSubmissionData.append("Subject", formData.subject);
      formSubmissionData.append("Message", formData.message);

      // Send form data to Google Apps Script
      const response = await fetch(scriptURL_SAVE, {
        method: "POST",
        body: formSubmissionData,
      });

      if (!response.ok) throw new Error("Network error");

      setFormStatus("Thank you! Your form has been submitted successfully.");

      // Small delay before redirect
      // setTimeout(() => {
      //   window.location.href = "/";
      // }, 300);

    } catch (error) {
      console.error("Error!", error.message);
      setFormStatus("There was an error submitting the form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container py-5" id="contact">
      <div className="d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between">
        <div className="col-12 col-lg-6 mb-4 d-flex flex-column justify-content-center pe-lg-5 pe-0 text-center text-lg-start">
          <div className="mb-4 fw-bold"
            style={{ fontSize: `${window.innerWidth < 768 ? 4 : 6}rem` }}>
            Contact Us
          </div>
          <p className="fs-5 mb-5">
            We’re here to help! Reach out with any questions or to learn more about our services.
          </p>
        </div>

        <div className="col-12 col-lg-6 mb-4
          d-flex flex-column justify-content-center align-items-center align-items-lg-end">
          <div className="card bg-white p-5"
            style={{
              maxWidth: "480px",
              width: "100%",
              minWidth: "360px"
            }}>
            <div className="fs-1 fw-semibold mb-3 text-dark mb-4">Contact form</div>
            {formStatus && <div className="alert alert-info">{formStatus}</div>}
            <form onSubmit={handleSubmit} className="mx-auto">
              <InputFieldDesign formData={formData} handleChange={handleChange} />
              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-primary px-5 py-2 mb-4 w-100 rounded-3 fs-5"
                  disabled={isSubmitting}
                  style={{ height: "50px" }}
                >
                  {isSubmitting ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      />
                      <span>Submitting...</span>
                    </div>
                  ) : (
                    "Send Message"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

const InputFieldDesign = ({ formData, handleChange }) => {
  return (
    <div className="py-4">
      <div className="form-group mb-4">
        <input type="text" className="form-control px-3" id="name" name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder=" " required
        />
        <label htmlFor="name" className="text-secondary">Name</label>
      </div>
      <div className="form-group mb-4">
        <input type="email" className="form-control px-3" id="email" name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder=" " required
        />
        <label htmlFor="email" className="text-secondary">Email</label>
      </div>
      <div className="form-group mb-4">
        <input type="text" className="form-control px-3" id="subject" name="subject"
          value={formData.subject}
          onChange={handleChange}
          placeholder=" "
          required
        />
        <label htmlFor="subject" className="text-secondary">Subject</label>
      </div>
      <div className="form-group mb-4">
        <textarea className="form-control ps-3" id="message" name="message" rows="4"
          value={formData.message}
          onChange={handleChange}
          placeholder="Message"
          required
        ></textarea>
      </div>
    </div>
  );
};
